
export const _updateNavigatorButtons = ( navigator = null, index = 0 ) => {

	if ( ! navigator ) {
		return;
	}

	const buttons = navigator.querySelectorAll( '[data-navigator-button]' );

	buttons.forEach( ( button, i ) =>
		i === index ? button.classList.add( 'is-active' ) : button.classList.remove( 'is-active' )
	);
};
